import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom"; // ✅ Import useNavigate()
import axios from "axios";
import { Spin, Alert } from "antd";
import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";

function Models() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate(); // ✅ Initialize navigation hook

  useEffect(() => {
    fetchVehicles();
  }, []);

  const fetchVehicles = async () => {
    try {
      const response = await axios.get("http://93.127.203.113:5005/vehicles");
      setVehicles(response.data);
    } catch (error) {
      setError("Failed to load vehicles. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleReserveClick = (vehicle) => {
    navigate("/book-car", { state: { vehicle } }); // ✅ Navigate with vehicle data
  };

  return (
    <>
      <section style={styles.modelsSection}>
        <HeroPages name="Vehicle Models" />
        <div style={styles.container}>
          {loading ? (
            <div className="loading-container">
              <Spin size="large" />
            </div>
          ) : error ? (
            <Alert message={error} type="error" showIcon />
          ) : (
            <div style={styles.modelsGrid}>
              {vehicles.map((vehicle) => (
                <div key={vehicle.id} style={styles.modelsCard}>
                  <div style={styles.modelsCardImage}>
                    <img
                      src={vehicle.vehicleImage ? `http://93.127.203.113:5005${vehicle.vehicleImage}` : "/images/cars-big/audi-a1.jpg"}
                      alt={vehicle.model}
                      style={styles.image}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/images/cars-big/audi-a1.jpg";
                      }}
                    />
                  </div>

                  <div style={styles.modelsCardContent}>
                    <h3 style={styles.cardTitle}>{vehicle.model}</h3>
                    <div style={styles.modelsCardDetails}>
                      <span>
                        <i className="fa-solid fa-car-side"></i> {vehicle.vehicle_type.typeName}
                      </span>
                      <span>
                        <i className="fa-solid fa-id-card"></i> {vehicle.plateNumber}
                      </span>
                      <span>
                        <i className="fa-solid fa-calendar"></i> {vehicle.manufacturedYear}
                      </span>
                      <span>
                        <i className="fa-solid fa-palette"></i> {vehicle.color}
                      </span>
                    </div>
                    <div style={styles.modelsCardBtn}>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          handleReserveClick(vehicle); // ✅ Navigate with vehicle data
                        }}
                        style={{ ...styles.bookButton, cursor: "pointer" }}
                      >
                        Reserve Car
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <Footer />
      </section>
    </>
  );
}

/* ✅ Inline styles */
const styles = {
  modelsSection: {
    padding: "60px 0",
    backgroundColor: "#f8f9fa",
  },
  container: {
    width: "90%",
    maxWidth: "1400px",
    margin: "0 auto",
  },
  modelsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "30px",
    marginTop: "30px",
  },
  modelsCard: {
    background: "white",
    borderRadius: "15px",
    boxShadow: "0 6px 15px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
    transition: "transform 0.3s ease-in-out",
    paddingBottom: "10px",
  },
  modelsCardImage: {
    width: "100%",
    height: "200px",
    overflow: "hidden",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
  modelsCardContent: {
    padding: "20px",
  },
  cardTitle: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#333",
  },
  modelsCardDetails: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    fontSize: "16px",
    color: "#555",
    marginTop: "15px",
  },
  modelsCardBtn: {
    marginTop: "20px",
    textAlign: "center",
  },
  bookButton: {
    display: "inline-block",
    backgroundColor: "#0c8c49",
    color: "white",
    padding: "12px 20px",
    borderRadius: "8px",
    fontSize: "16px",
    textTransform: "uppercase",
    fontWeight: "bold",
    textDecoration: "none",
    transition: "background 0.3s ease",
  },
  bookButtonHover: {
    backgroundColor: "#09733a",
  },
};

/* ✅ Responsive Design */
styles.modelsGrid["@media (max-width: 1024px)"] = {
  gridTemplateColumns: "repeat(2, 1fr)",
};
styles.modelsGrid["@media (max-width: 768px)"] = {
  gridTemplateColumns: "repeat(1, 1fr)",
};

export default Models;
